import React from 'react'

const Tag = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/tag',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill={primaryColor} fillRule='nonzero'>
      <path d='M9.473 1l-6.845.168a1.498 1.498 0 0 0-1.46 1.46L1 9.473c0 .407.144.814.43 1.101l7.445 7.445c.622.622 1.46.981 2.346.981a3.22 3.22 0 0 0 2.345-.981l4.453-4.429c.622-.622.981-1.46.981-2.345a3.22 3.22 0 0 0-.981-2.346L10.574 1.43C10.287 1.144 9.88 1 9.474 1zm8.297 10.283c0 .516-.197 1.007-.565 1.376l-4.546 4.546c-.369.368-.86.565-1.376.565a1.933 1.933 0 0 1-1.376-.565L2.265 9.563c-.025-.025-.025-.025-.025-.05l.172-7.027c0-.025.025-.074.074-.074l7.028-.172c.024 0 .024 0 .049.025l7.642 7.642c.368.368.565.86.565 1.376z' />
      <path d='M5.39 5.383a2.718 2.718 0 0 0 0 3.831A2.724 2.724 0 0 0 7.3 10c.686 0 1.371-.27 1.91-.786a2.718 2.718 0 0 0 0-3.831c-1.053-1.056-2.767-1.032-3.82 0zm2.994 2.99c-.573.576-1.54.576-2.143 0-.574-.575-.574-1.543 0-2.149a1.514 1.514 0 0 1 1.057-.454c.392 0 .784.151 1.056.454.604.575.604 1.544.03 2.15z' />
    </g>
  </svg>
)

export default Tag
